import { getByCategory, getCategory } from '../data/vocabulary.js';
import { WordCard } from '../components/WordCard.js';
import { NotFound } from './NotFound.js';

export function VocabCategory(root, params) {
  const cat = getCategory(params.category);
  if (!cat) return NotFound(root);

  const words = getByCategory(cat.id);

  root.innerHTML = `
    <header class="mb-10">
      <a href="/vocab" data-link
         class="text-sm text-slate2-500 hover:text-moss-700">← All vocabulary</a>
      <div class="flex items-center gap-3 mt-3">
        <div class="text-4xl">${cat.icon}</div>
        <div>
          <h1 class="font-display text-3xl sm:text-4xl font-semibold
                     text-slate2-900 tracking-tight">${cat.title}</h1>
          <div class="text-sm text-moss-700 font-medium">${cat.norwegian}</div>
        </div>
      </div>
      <p class="mt-3 text-slate2-500 max-w-2xl leading-relaxed">${cat.description}</p>
    </header>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      ${words.map(WordCard).join('')}
    </div>

    <div class="mt-10 flex flex-wrap gap-3">
      <a href="/flashcards" data-link class="btn-primary">
        Practice these in flashcards →
      </a>
      <a href="/grammar/building-blocks" data-link class="btn-secondary">
        Try the sentence builder
      </a>
    </div>
  `;
}
